// import Vue from 'vue'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import mitt from 'mitt'
const emitter = mitt()

const app = createApp(App)

app.config.globalProperties.emitter = emitter

// app.config.globalProperties.alertJoa = function ($1, $2, $3) {
//   this.emitter.emit('my-event', { open: true, msg: $1, type: $2, confirm: $3 })
// }

app.config.globalProperties.alertJoa = function ($1, $2, $3) {
  this.emitter.emit('my-event', { open: true, msg: $1, type: $2, confirm: $3 })
  return new Promise((resolve) => {
    const handler = (response) => {
      resolve(response)
      this.emitter.off('modal-response', handler) // Elimina el listener después de la primera invocación
    }

    this.emitter.on('modal-response', handler)
  })
} // Esto es de iacita

app.use(store).use(router).mount('#app')
